import store from '@/store';
export function getPermission(val) {
  const permissionList = store.state.user.permissionList;
  return permissionList.includes(val);
}
